import React, {Component} from 'react';
import Cookie from 'js-cookie';
import $ from 'jquery';

import Error from 'lib/struct/Error';
import 'vendor/redactor/2/redactor.css';
import 'vendor/redactor/2/redactor.min';
import 'vendor/redactor/2/ru';
import 'vendor/jquery-wa/editor2';

import styles from './RedactorTextarea.css';

const {
	'redactor-textarea': redactor_block_class,
	'redactor-textarea_invalid': invalid_textarea_class,
	'redactor-textarea__control': textarea_class,
} = styles;

export default class RedactorTextarea extends Component {
	componentDidMount() {
		const htmlHandler = (html) => {
			html = html.replace(/{[a-z$][^}]*}/gi, (match, offset, full) => {
				const i = full.indexOf("</script", offset + match.length);
				const j = full.indexOf('<script', offset + match.length);

				if (i === -1 || (j !== -1 && j < i)) {
					match = match.replace(/&gt;/g, '>');
					match = match.replace(/&lt;/g, '<');
					match = match.replace(/&amp;/g, '&');
					match = match.replace(/&quot;/g, '"');
				}

				return match;
			});

			return html;
		};

		const {redactor_options} = this.props;

		$(this.wysiwyg).waEditor({
			lang: 'ru',
			toolbarFixed: false,
			minHeight: 150,
			focus: false,
			...redactor_options,
			uploadFields: {
				_csrf: Cookie.get('_csrf')
			},
			callbacks: {
				change: (val) => {
					this.changed = true;

					$(this.wysiwyg).waEditor("sync");
					const {onChange} = this.props;
					const e = $.Event('change', {target: this.wysiwyg});

					if (onChange) {
						onChange(e);
					}
				},
				sync: (html) => {
					this.wysiwyg.value = htmlHandler(html);
				}
			}
		});
	}

	componentDidUpdate() {
		if (this.changed) {
			this.changed = false;
			return;
		}

		const $textarea = $(this.wysiwyg);
		const {value} = this.props;
		const $redactor = $textarea.data('redactor');

		if ($redactor.clean.onSet(value) != $redactor.$editor.html()) {
			$redactor.code.set(value);
		}

		if (value != $textarea.data('ace').getValue()) {
			$textarea.data('ace').setValue($textarea.val(), -1);
		}
	}

	render() {
		const {className, error, ...props} = this.props;
		const classes = [];
		classes.push(redactor_block_class);
		classes.push("wa-editor-core-wrapper s-editor-core-wrapper");

		if (error) {
			classes.push(invalid_textarea_class);
		}

		if (className) {
			classes.push(className);
		}

		return (
			<div className={classes.join(' ')}>
				<ul className="wa-editor-wysiwyg-html-toggle s-wysiwyg-html-toggle">
					<li className="selected"><a className="wysiwyg" href="#">Визуальный редактор</a></li>
					<li><a className="html" href="#">HTML</a></li>
				</ul>
				<div>
					<textarea className={textarea_class} {...props}
						ref={(input) => this.wysiwyg = input} />
				</div>

				<Error error={error}/>
			</div>
		);
	}
}